import React from 'react';
import Manage from './Manage';
import { UsersProvider } from '../../../contexts/UserContext';

const UsersPage = () => {
    return (
        <UsersProvider>
            <Manage />
        </UsersProvider>
    );
};

export default UsersPage;
